









import { Vue, Component, Prop, Ref } from 'vue-property-decorator';
import * as markdown from '../markdown';

declare global {
  interface Window {
    MathJax?: {
      tex: any;
      startup: {
        typeset: boolean;
        elements?: HTMLElement[];
        ready: () => void;
        defaultReady?: () => void;
      };
      typeset?: (elements?: HTMLElement[]) => void;
      options: any;
      loader: any;
    };
  }
}

@Component
export default class Markdown extends Vue {
  @Prop() markdown!: string;
  @Ref() root!: HTMLElement;
  @Prop({ default: false }) fullWidth!: boolean;

  markdownConverter = new markdown.Converter();

  get html(): string {
    return this.markdownConverter.makeHtml(this.markdown);
  }

  mounted(): void {
    this.root.innerHTML = this.html;
  }
}
